<template>
  <div class="flex-item" :style="styleObject"><slot /></div>
</template>
<script>
export default {
  name: "flex-item",
  props: {
    grow: {
      type: Number,
      default: 1,
    },
    shrink: {
      type: Number,
      default: 1,
    },
    basis: {
      type: String,
      default: "auto",
    },
  },
  computed: {
    styleObject() {
      const { grow, shrink, basis } = this.$props;
      const object = {};
      if (grow !== 1) {
        object["flexGrow"] = grow;
      }
      if (shrink !== 1) {
        object["flexShrink"] = shrink;
      }
      if (basis !== "auto") {
        object["flexBasis"] = basis;
      }
      return object;
    },
  },
};
</script>
<style scoped>
.flex-item {
  flex: auto;
  overflow: auto;
}
</style>
